"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./CircleComponent.scss");
const CircleComponent = ({ backgroundColor = 'var(--base-600)', borderColor = 'var(--base-600)', opacity = '100%', size = 'normal', containerClass = '', onClick, pointerEvent = 'cursor-pointer', isChecked = false, name = '', disabled, children }) => {
    const pixel = size === 'small' ? '16px' : '24px';
    backgroundColor = isChecked ? backgroundColor : 'transparent';
    const getBorderColor = () => {
        if (disabled)
            return 'grey';
        return isChecked ? borderColor : 'var(--n-600)';
    };
    const getOpacity = () => {
        return disabled ? '0.5' : opacity;
    };
    const getPointerEvent = () => {
        return disabled ? 'pointer-events-none' : pointerEvent;
    };
    const getContainerClass = () => {
        return `
      ${containerClass ? containerClass : 'circle-container'}
      ${disabled ? 'cursor-not-allowed' : ''}
    `;
    };
    return (react_1.default.createElement("div", { className: getContainerClass() },
        react_1.default.createElement("div", { className: `outer-content ${getPointerEvent()}`, style: {
                backgroundColor: backgroundColor,
                borderColor: getBorderColor(),
                opacity: getOpacity(),
                width: pixel,
                height: pixel
            }, id: name, onClick: (e) => onClick && onClick(e, isChecked), "data-cy": name }, children)));
};
exports.default = CircleComponent;
